export const AUTH_CONSTANTS = {
  PATH_SIGNUP: '/signup',
  PATH_SIGNIN: '/signin',
  PATH_LOGOUT: '/logout',
  PATH_FORGOT: '/forgot',
  PATH_RESET: '/reset',
  PATH_VERIFY: '/verify',
  PATH_CONFIRM: '/confirm',
  PATH_REFRESH: '/refresh',
  PATH_SESSION: '/session',
  PATH_PROFILE: '/profile',
  PATH_LIST: '/list',
  PATH_GOOGLE_LOGIN: '/google/login',
  PATH_FACEBOOK_LOGIN: '/facebook/login',
  PATH_MAGIC_LINK_REQUEST: '/magic-link/request',
  PATH_MAGIC_LINK_VERIFY: '/magic-link/verify',
  PATH_OTP_EMAIL_REQUEST: '/otp/email/request',
  PATH_OTP_EMAIL_VERIFY: '/otp/email/verify',
  PATH_OTP_WHATSAPP_REQUEST: '/otp/whatsapp/request',
  PATH_OTP_WHATSAPP_VERIFY: '/otp/whatsapp/verify',
  PATH_PHONE_LINK_REQUEST: '/phone/link/request',
  PATH_PHONE_LINK_VERIFY: '/phone/link/verify',
  PATH_UNLINK_IDENTITY: '/identities',
  PATH_SET_PASSWORD: '/password',
  PATH_MFA_REQUEST: '/mfa/request',
  PATH_MFA_VERIFY: '/mfa/verify',
  PATH_MFA_ENABLE: '/mfa/enable',
  PATH_MFA_DISABLE: '/mfa/disable',
} as const;
